import AdminLayout from "components/admin/layout"
import AppHistory from "shared/history"
import Button from "components/inputs/button"
import {digg} from "diggerize"
import {FlashNotifications as FlashMessage} from "flash-notifications"
import I18n from "shared/i18n"
import inflection from "inflection"
import Input from "components/inputs/input"
import Locales from "shared/locales"
import PageComponent from "components/page-component"
import PropTypes from "prop-types"
import React from "react"
import Routes from "shared/routes"
import {Styling} from "models"
import {v4 as uuidv4} from "uuid"
import withModel from "components/wooftech-with-model"
class RoutesAdminStylingsEdit extends PageComponent {
  static propTypes = {
    styling: PropTypes.instanceOf(Styling),
    stylingId: PropTypes.string
  }

  render() {
    const {onSubmit} = this.t
    const {styling} = this.p

    return (
      <AdminLayout active="stylings" className="routes--admin--stylings--edit" headerTitle={this.headerTitle()}>
        {styling &&
          <form onSubmit={onSubmit}>
            {Locales.availableLocales().map((locale) =>
              <React.Fragment key={locale}>
                <Input
                  attribute={`name${inflection.camelize(locale)}`}
                  label={`${Styling.humanAttributeName("name")} (${Locales.labelForLocale(locale)})`}
                  model={styling}
                />
              </React.Fragment>
            )}
            <Input
              attribute="styling"
              defaultValue={styling.styling() ? JSON.stringify(styling.styling(), null, 2) : ""}
              model={styling}
              type="textarea"
            />
            <Button primary save />
          </form>
        }
      </AdminLayout>
    )
  }

  headerTitle() {
    const {styling} = this.p

    if (styling?.isNewRecord()) {
      return I18n.t("js.routes.admin.stylings.edit.add_new_styling")
    } else if (styling?.isPersisted()) {
      return I18n.t("js.routes.admin.stylings.edit.edit_styling", {name: styling.name()})
    }
  }

  onSubmit = async (e) => {
    e.preventDefault()

    const form = digg(e, "target")
    const formData = new FormData(form)
    const {styling} = this.p

    if (styling.isNewRecord()) formData.append("styling[id]", styling.id())

    // Convert the styling to proper and pretty JSON
    let stylingString = formData.get("styling[styling]")

    if (stylingString) {
      try {
        stylingString = JSON.parse(stylingString)
      } catch (error) {
        FlashMessage.alert(error.message)

        return
      }

      formData.set("styling[styling]", JSON.stringify(stylingString, null, 2))
    }

    try {
      await styling.saveRaw(formData, {form})
      FlashMessage.success(I18n.t("js.routes.admin.stylings.edit.the_styling_was_saved"))
      AppHistory.push(Routes.adminStylingPath(styling.id()))
    } catch (error) {
      FlashMessage.errorResponse(error)
    }
  }
}

const selectedStylingAttributes = ["id", "name", "styling"]

for (const locale of Locales.availableLocales()) {
  selectedStylingAttributes.push(`name${locale.substring(0, 1).toUpperCase()}${locale.substring(1, 99)}`)
}

export default withModel(
  RoutesAdminStylingsEdit,
  Styling,
  {
    newIfNoId: {
      defaults: () => ({id: uuidv4()})
    },
    select: {
      Styling: selectedStylingAttributes
    }
  }
)
